import { Injectable } from '@angular/core';
import { BaseComponent } from '@app/base/base.component';
import { Network } from '@ionic-native/network/ngx';
import { Platform } from '@ionic/angular';
import { AppConsts } from '@shared/AppConsts';
import { filter } from 'rxjs/internal/operators/filter';
import { Globals } from '../globals';
import { StringUtils } from '@shared/utils/StringUtils';
@Injectable({
  providedIn: 'root'
})
export class NetworkServicesService {
  private readonly REFRESH_TYPES = new Set(['4g', 'wifi', '3g', '2g']);
  private lastType: string = null;
  public refresh$: any;
  constructor(private network: Network,  private globals: Globals, private platform: Platform) {
    if(StringUtils.isMobilePlatform(platform)) {
      this.refresh$ = this.network.onChange().pipe(
        filter(() => {
          // tslint:disable-next-line: triple-equals
          if (this.network.type != 'none') {
            console.log('get network connection!');
            this.globals.showNoInternet = false;
            this.globals.showData = true;
            return true;
          } else {
            this.globals.showNoInternet = true;
            this.globals.showData = false;
            if(BaseComponent.alertCu != null) {
              BaseComponent.alertCu.dismiss();
            }
            return false;
          }
        })
      );
    }
  }
}